import { Directive, inject, TemplateRef } from '@angular/core';

@Directive({
  selector: '[fExtendedFileSelectTemplate]'
})
export class FireflyExtendedFileSelectTemplateDirective {
  template = inject(TemplateRef<unknown>);
}
